import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { colors } from "../../../Shared/colors";
import { AddNewLeadsSecond } from "./AddNewLeadsSecond";
import SearchIcon from "@mui/icons-material/Search";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSearchClientQuery } from "../../../features/clientSlice";
import { Puff } from "react-loader-spinner";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { toast } from "react-hot-toast";
import Papa from "papaparse";
import {
  useAddClinetLeadCSVMutation,
} from "../../../features/taskSlice";
import { useGetAllProjectsQuery } from "../../../features/projectSlice";
import CsvBtn from "./CsvBtn";
import { decryptData } from "../../../services/crypto";


export const AddNewLeadsFirst = () => {
  const [phone, setphone] = useState("92");
  const [isUploading, setIsUploading] = useState(false);
  const [skip, setskip] = useState(true);

  const [projectId, setprojectId] = useState("");

  let { data: project } = useGetAllProjectsQuery();

  const handlePhone = (e) => {
    setphone(e);
    if (skip === false) {
      setskip(true);
    }
  };
  const handleReset = () => {
    setphone("92");
    if (skip === false) {
      setskip(true);
    }
  };

  let {
    data: phoneData,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useSearchClientQuery(phone, {
    skip,
  });

  // const isDuplicateEmployeeCalled = useRef(false); // Removed - no longer needed

  // Removed duplicate notification - backend already handles this via sendClientSearchNotification
  // useEffect(() => {
  //   if (error && role !== "ceo") {
  //     let data = {
  //       empId: error?.data?.empId,
  //       type: "private",
  //       message: `${empName} (${loginEmpNum}) tried to add your existing lead with the number ${phone}`,
  //     };
  //     if (!isDuplicateEmployeeCalled.current) {
  //       duplicateEmployee(data.empId, data.type, data.message);
  //       isDuplicateEmployeeCalled.current = true;
  //     }
  //   } else {
  //     isDuplicateEmployeeCalled.current = false;
  //   }
  // }, [error]);

  let searchNumber = (e) => {
    setskip(false);
  };

  let handleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchNumber();
    } else if (e.key === "Escape") {
      handleReset();
    }
  };

  const [addClinetLeadCSV] = useAddClinetLeadCSVMutation();

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (file) {
      setIsUploading(true); 
      const formData = new FormData();
      formData.append("projectId", projectId);
      formData.append("file", file);

      try {
        const res = await addClinetLeadCSV(formData).unwrap();
        const { message, addedCount, alreadyExistClient } = res;

        toast.success(
          <div>
            <h4>{message}</h4>
            <p>
              New Clients Added: <strong>{addedCount}</strong>
            </p>
            <p>Already Existing Clients:</p>
            <ul style={{ maxHeight: "100px", overflowY: "scroll" }}>
              {Array.isArray(alreadyExistClient) &&
                alreadyExistClient.slice(0, 5).map((phone, index) => (
                  <li key={index}>📞 {phone}</li>
                ))}
            </ul>
            {Array.isArray(alreadyExistClient) && alreadyExistClient.length > 5 && (
              <p>...and {alreadyExistClient.length - 5} more duplicates</p>
            )}
          </div>,
          {
            position: "top-center",
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "custom-toast",
          }
        );
      } catch (err) {
        toast.error(err?.data?.error?.message || "Something went Wrong");
      } finally {
        setIsUploading(false); 
      }

    }
    e.target.value = ""; 
  };

  return (
    <>
      <Main>
        <HeaderSection>
          <Heading>Add New Lead</Heading>
          <SubHeading>Search for existing client or upload CSV file to create new leads</SubHeading>
        </HeaderSection>
        
        <FormSection>
          <PhoneSection>
            <PhoneLabel>Phone Number</PhoneLabel>
            <PhoneInputContainer>
              <PhoneInput
                inputProps={{ name: "phone", required: true }}
                country="pk"
                value={phone}
                placeholder="Enter phone number"
                onChange={handlePhone}
                onKeyDown={handleKeyDown}
              />
              <SearchButton onClick={searchNumber}>
                <SearchIcon />
              </SearchButton>
              <ClearButton onClick={handleReset}>
                <img src="/assets/icons/cross.png" alt="clear" />
              </ClearButton>
            </PhoneInputContainer>
          </PhoneSection>

          {phone.length <= 2 && (
            <AlternativeSection>
              <Divider>
                <DividerLine />
                <DividerText>OR</DividerText>
                <DividerLine />
              </Divider>
              
              <CsvGuideSection>
                <GuideHeader>
                  <GuideTitle>📋 Upload Leads via CSV</GuideTitle>
                  <GuideSubtitle>Bulk upload multiple leads at once</GuideSubtitle>
                </GuideHeader>

                <CompactSteps>
                  <StepRow>
                    <StepNumber>1</StepNumber>
                    <StepContent>
                      <StepTitle>Download Format</StepTitle>
              <CsvBtn />
                    </StepContent>
                  </StepRow>

                  <StepRow>
                    <StepNumber>2</StepNumber>
                    <StepContent>
                      <StepTitle>Select Project</StepTitle>
                      <ProjectSection>
                        <ProjectSelect>
                  <select
                    name="leadInterestedProjectID"
                    id="leadInterestedProjectID"
                    onChange={(e) => setprojectId(e.target.value)}
                  >
                    <option value="" disabled selected>
                              Select Project
                    </option>
                    {project?.map((pro) => (
                              <option key={pro._id} value={pro._id}>{pro.projectName}</option>
                    ))}
                  </select>
                        </ProjectSelect>
                      </ProjectSection>
                    </StepContent>
                  </StepRow>

                  <StepRow>
                    <StepNumber>3</StepNumber>
                    <StepContent>
                      <StepTitle>Upload CSV File</StepTitle>
                      <FileUploadSection>
                        <FileUploadLabel>
                          CSV File Upload
                          <FileUploadNote>Max 1000 rows • .csv only</FileUploadNote>
                        </FileUploadLabel>
                {isUploading ? (
                          <UploadLoader>
                    <Puff
                              height="40"
                              width="40"
                      radius={1}
                      color={colors.brown}
                      ariaLabel="puff-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    />
                      <UploadText>Uploading...</UploadText>
                    </UploadLoader>
                  ) : (
                    <FileUploadArea>
                      <FileUploadContent>
                        <AttachFileIcon />
                        <FileUploadText>Upload CSV file here</FileUploadText>
                        <FileUploadButton htmlFor="profilePic">
                          Choose File
                        </FileUploadButton>
                      </FileUploadContent>
                    <input
                      type="file"
                      name="profilePic"
                      id="profilePic"
                      onChange={(e) => handleFileUpload(e)}
                        accept=".csv"
                      />
                    </FileUploadArea>
                        )}
                      </FileUploadSection>
                    </StepContent>
                  </StepRow>
                </CompactSteps>

                <RequirementsSection>
                  <RequirementsTitle>📋 CSV Requirements</RequirementsTitle>
                  <RequirementsGrid>
                    <RequirementItem>📄 .csv files only</RequirementItem>
                    <RequirementItem>📊 Max 1000 rows</RequirementItem>
                    <RequirementItem>📱 Phone: 123-456-7890</RequirementItem>
                    <RequirementItem>🏢 Separate by project</RequirementItem>
                  </RequirementsGrid>
                </RequirementsSection>
              </CsvGuideSection>
            </AlternativeSection>
          )}
        </FormSection>

        <ResultSection>
        {isLoading ? (
            <LoadingContainer>
            <Puff
              height="50"
              width="50"
              radius={1}
              color={colors.brown}
              ariaLabel="puff-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
              <LoadingText>Searching for client...</LoadingText>
            </LoadingContainer>
        ) : isSuccess ? (
          <AddNewLeadsSecond mainPhoneNumber={phone} phoneData={phoneData} />
        ) : isError ? (
            <ErrorContainer>
              <ErrorIcon>⚠️</ErrorIcon>
              <ErrorText>{error?.data?.message}</ErrorText>
            </ErrorContainer>
        ) : null}
        </ResultSection>
      </Main>
    </>
  );
};

const Main = styled.div`
  background: white;
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown} 0%, #8B4513 100%);
  }
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 1rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f1f3f4;
`;

const Heading = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 0.75rem 0;
  letter-spacing: -0.5px;
`;

const SubHeading = styled.p`
  color: #6c757d;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 400;
  line-height: 1.5;
`;

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const PhoneSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #e9ecef;
`;

const PhoneLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const PhoneInputContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  
  .react-tel-input {
    .form-control {
      width: 100%;
      height: 56px;
      border-radius: 8px;
      border: 1px solid #d1d5db;
      padding: 0 60px 0 60px;
      font-size: 0.95rem;
      background: white;
      font-weight: 400;
      color: #374151;
      
      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        outline: none;
      }
      
      &::placeholder {
        color: #9ca3af;
        font-weight: 400;
      }
    }
    .flag-dropdown {
      border: 1px solid #d1d5db;
      border-radius: 8px 0 0 8px;
      background-color: white;
      border-right: none;
    }
    .selected-flag,
    .selected-flag:hover {
      background: none;
    }
  }
`;

const SearchButton = styled.button`
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, ${colors.brown} 0%, #8B4513 100%);
  color: white;
  border: none;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(139, 69, 19, 0.3);
  
  &:hover {
    transform: translateY(-50%) translateY(-2px);
    box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);
  }
`;

const ClearButton = styled.button`
    position: absolute;
  right: 12px;
    top: 50%;
    transform: translateY(-50%);
  background: none;
  border: none;
    cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(220, 53, 69, 0.1);
  }
  
  img {
    width: 18px;
    height: 18px;
  }
`;

const AlternativeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #e9ecef;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin: 1rem 0;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, #dee2e6, transparent);
`;

const DividerText = styled.span`
  color: #6c757d;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  background: #f8f9fa;
  border-radius: 20px;
  border: 1px solid #dee2e6;
`;

const CsvGuideSection = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
  margin-top: 1.5rem;
`;

const GuideHeader = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
`;

const GuideTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 0.25rem 0;
  letter-spacing: -0.5px;
`;

const GuideSubtitle = styled.p`
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
  font-weight: 400;
`;

const CompactSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const StepRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, ${colors.brown} 0%, #8B4513 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1rem;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(139, 69, 19, 0.3);
`;

const StepContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const StepTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  min-width: 120px;
`;

const RequirementsSection = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #e9ecef;
`;

const RequirementsTitle = styled.h4`
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.75rem 0;
`;

const RequirementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.5rem;
`;

const RequirementItem = styled.div`
  font-size: 0.8rem;
  color: #495057;
  padding: 0.5rem;
  background: #f8f9fa;
    border-radius: 6px;
  text-align: center;
  border-left: 3px solid ${colors.brown};
`;

const UploadSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ProjectSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const ProjectLabel = styled.label`
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
`;

const Required = styled.span`
  color: #dc3545;
  margin-left: 4px;
`;

const ProjectSelect = styled.div`
  select {
    width: 100%;
    padding: 14px 16px;
    border: 2px solid #e9ecef;
    border-radius: 10px;
    font-size: 1rem;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 4px rgba(139, 69, 19, 0.1);
    outline: none;
    }
  }
`;

const FileUploadSection = styled.div`
    display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const FileUploadLabel = styled.label`
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
`;

const FileUploadNote = styled.span`
  display: block;
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 400;
  margin-top: 0.25rem;
`;

const FileUploadArea = styled.div`
    position: relative;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  padding: 2rem;
  background: white;
  transition: all 0.3s ease;
      cursor: pointer;
  
  &:hover {
    border-color: ${colors.brown};
    background: rgba(139, 69, 19, 0.02);
    transform: translateY(-2px);
  }
  
  input[type="file"] {
    display: none;
  }
`;

const FileUploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
`;

const FileUploadText = styled.p`
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
`;

const FileUploadButton = styled.label`
  background: linear-gradient(135deg, ${colors.brown} 0%, #8B4513 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(139, 69, 19, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);
  }
`;

const UploadLoader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
`;

const UploadText = styled.p`
  color: ${colors.brown};
  font-weight: 600;
  margin: 0;
`;

const ResultSection = styled.div`
  margin-top: 1rem;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
`;

const LoadingText = styled.p`
  color: ${colors.brown};
  font-weight: 600;
  margin: 0;
`;

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #ffe6e6 0%, #ffcccc 100%);
  border: 1px solid #ff6b6b;
  border-radius: 12px;
  margin-top: 1rem;
`;

const ErrorIcon = styled.span`
  font-size: 1.5rem;
`;

const ErrorText = styled.p`
  color: #e74c3c;
  font-weight: 600;
  margin: 0;
`;
